import React from 'react';

export default function IconInsider() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7411_62873)">
        <g clipPath="url(#clip1_7411_62873)">
          <path
            d="M1.5 5.25L1.5 12.7495C1.5 13.4398 2.05961 13.9995 2.74995 13.9995L13.2499 13.9999C13.9403 14 14.5 13.4403 14.5 12.7499V5.25C14.5 4.55964 13.9404 4 13.25 4H2.75C2.05964 4 1.5 4.55964 1.5 5.25Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.5 3.93701V2.69326C5.5 2.00576 6.0625 1.44326 6.75 1.44326L9.24375 1.44326C9.93125 1.44326 10.4937 2.00576 10.4937 2.69326V3.93701L5.5 3.93701Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.875 9.84131H5.5L7.16875 11.5101"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.125 7.96709H10.5L8.83125 6.29834"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7411_62873">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_7411_62873">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
